import { ACCESS_CODE_ADD } from './index';
import { Action } from '../action';
import { AccessCodeSearchInfo } from '@shared/core';

export class AccessCodeAddInitAction implements Action {
	readonly type = ACCESS_CODE_ADD.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AccessCodeAddDestroyAction implements Action {
	readonly type = ACCESS_CODE_ADD.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AccessCodeAddFormUpdateAction implements Action {
	readonly type = ACCESS_CODE_ADD.FORM_UPDATE;
	constructor(
		public payload: AccessCodeSearchInfo,
		public correlationId?: number
	) {}
}

export class AccessCodeAddSubmitAction implements Action {
	readonly type = ACCESS_CODE_ADD.SUBMIT;
	constructor(
		public payload: AccessCodeSearchInfo,
		public correlationId?: number
	) {}
}
